<div class="chart card">
  <div class="chart-wrapper">
    <div class="chart-container" [id]="id">
      @if (loadingChart) {
        <div class="loading">
          @if (errorMessageChart == null) {
            <giq-small-load></giq-small-load>
            <div>Loading data. . .</div>
          }
          @if (errorMessageChart != null) {
            <mat-icon>error</mat-icon>
            <div>{{ errorMessageChart }}</div>
          }
        </div>
      }
    </div>
  </div>
  @if (hideIndicators) {
    <div class="labels">
      @for (key of keys; track key) {
        <div
          class="label"
          [style.--indicator]="color(key)"
          [matTooltip]="names[key]"
          (mouseenter)="highlight(key)"
          (mouseleave)="unhighlight()"
        ></div>
      }
    </div>
  }
  @if (!hideIndicators) {
    <div class="labels">
      @for (key of keys; track key) {
        <div
          class="label"
          [style.--indicator]="color(key)"
          (mouseenter)="highlight(key)"
          (mouseleave)="unhighlight()"
          >
          {{ names[key] }}
        </div>
      }
    </div>
  }
</div>
